import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import css from "./Jobs.module.css";
import PageHead from "../../../Components/PageHead/PageHead";
import DataTable from "../../../Components/DataTable/DataTable";
import { Get } from "../../../Services/Server";
import Url from "../../../Services/Url";
import Time from "../../../Services/Time";
import Utils from "../../../Services/Utills";

const statusText = {
	initial: "New Task",
	requirements: "Requirements",
	risk: "Risk Assessment",
	contract: "Contract",
	null: "null",
};
const reader = (e) => {
	const statusIndex = e.status
		.split(",")
		.splice(1)
		.findIndex((s) => s < 3);
	const status = Object.keys(statusText)[statusIndex];
	const delivery = e.createdAt ? Time.getDate(e.createdAt) : "null";
	return [
		e.company,
		<div className={css[status] + " " + css.status}>{statusText[status]}</div>,
		delivery,
		"View",
	];
};

const JobReader = (rec) => {
	return [rec.companyName, rec.site, "Starlink", "View"];
};

const JobsList = ({ navoption, ModalAction }) => {
	const heading = ["Status", "Estimated Delivery", ""];
	const pendingHeading = ["Site", "Equipment", ""];
	const [data, setData] = useState([]);
	const [list, setList] = useState([]);
	const [ongoing, setOngoing] = useState();
	const [previous, setPrevious] = useState();
	const [pending, setPending] = useState();
	const [view, setView] = useState("pending");
	const [page, setPage] = useState({ pageable: null, totalPage: null });
	const navigate = useNavigate();
	const headingFlex = [20, 20, 20, 15, 15, 10];
	const dropOptions = {
		onClick: (e) => {
			const selectedOption = e.find((o) => o.selected);
			if (selectedOption) {
				const selectedView = selectedOption.text.toLowerCase();
				setView(selectedView);
			}
		},
		list: ["Pending", "Ongoing", "Completed"],
	};

	useEffect(() => {
		loadData("pending", 0);
		loadData("ongoing", 0);
		loadData("completed", 0);
	}, []);

	const loadData = (type, pg) => {
		let url;
		if (type === "pending") url = Url.sales.getAllEnterprise(false, pg);
		else if (type === "ongoing")
			url = Url.sales.getAllEnterpriseInitDTO(false, pg);
		else if (type === "completed")
			url = Url.sales.getAllEnterpriseInitDTO(true, pg);

		Get(url).then((resp) => {
			setData((prev) => ({ ...prev, [type]: { ...resp, type } }));
		});
	};
	const handleAddJob = () => {
		navigate("Create");
	};

	const handleClick = (e) => {
		if (view === "pending") {
			navigate("CreateStarlink", { state: e });
		} else {
			navigate(`${e.id}`, { state: e });
		}
	};
	const handlePagination = (pg) => {
		loadData(view, pg);
	};

	const onSearch = (e) => {
		setData(
			list.filter((l) => l.title.toLowerCase().includes(e.toLowerCase()))
		);
	};

	return (
		<div className={css.Jobs}>
			<PageHead
				initiateBtn={{ text: "Job", onClick: handleAddJob }}
				navoption={navoption}
				onSearch={onSearch}
				hideIcon={true}
				title="Jobs"
				dropOptions={dropOptions}
				filter={Utils.toPascalCase(view)}
			/>
			<div className={css.Record}>
				{data[view]?.content && (
					<DataTable
						flex={headingFlex}
						handlePagination={handlePagination}
						onClick={handleClick}
						pageable={data[view]?.pageable}
						reader={view === "pending" ? JobReader : reader}
						totalPages={data[view]?.totalPages}
						transform={Utils.toPascalCase}
					>
						{{
							heading: [
								`${view?.charAt(0).toUpperCase() + view?.slice(1)} Jobs`,
								...(view === "pending" ? pendingHeading : heading),
							],
							data: data[view]?.content,
						}}
					</DataTable>
				)}
			</div>
		</div>
	);
};

export default JobsList;
